<div class="widget widget_archive">
    <h2 class="widget-title">Archives</h2>
    <ul>
        <li *ngFor="let list of List"><a href='#'>{{ list.year }}</a></li>
    </ul>
</div>